import { FC } from "react";

const SafetyNetSettings: FC = () => {
  return <>TODO</>;
};

export default SafetyNetSettings;
